import { KeyValue } from '@delmonicos/shared-design-system-react/src/components/filter-selector/filter-selector';
import { FilterToggle } from '@delmonicos/shared-design-system-react/src/components/filter-toggle/filter-toggle';
import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { InvoiceStatus } from '@delmonicos/shared-sdk/libs/cpms/src/libs/invoices-service-lib/src/wrapper/enums/invoice-status.enum';
import { useTranslation } from 'react-i18next';

import {
  InvoiceStatusEnum,
  mapStatusToGenericInvoiceStatus,
} from '@app/feature/invoice/helper/invoice-status.helper';

interface InvoiceStatusFilterControllerProps {
  onChange: (itemIds: string[]) => void;
  selectedItemIds: string[];
}

export const InvoiceStatusFilterController = ({
  onChange,
  selectedItemIds,
}: InvoiceStatusFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const invoiceStatusList = Object.values(InvoiceStatusEnum).map(
    (invoiceStatus) => ({
      key: invoiceStatus.name,
      value: t(
        `delmonicos-shared-sdk.enums-invoice-status.${invoiceStatus.name}`,
      ),
    }),
  );

  const additionalBackgroundColor = (item: KeyValue) => {
    return mapStatusToGenericInvoiceStatus(item.key as InvoiceStatus).color;
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="file-05"
        text={t('delmonicos-shared-sdk.outputs-invoice.status')}
      />
      <FilterToggle
        initialSelectedItemIds={selectedItemIds}
        items={invoiceStatusList}
        onChange={onChange}
        additionalBackgroundColor={additionalBackgroundColor}
      />
    </Stack>
  );
};
